import CrudModule from "@/components/CrudModule";
import { MODULES } from "@/config/modules";

const LEGEND = [
  { dot: "bg-emerald-500", label: "Green — Preferred / reliable" },
  { dot: "bg-amber-500", label: "Orange — Testing / limited data" },
  { dot: "bg-red-500", label: "Red — Avoid unless necessary" },
];

export default function Scorecard() {
  return (
    <div>
      <div className="mb-4 flex flex-wrap gap-4 rounded-lg border border-border bg-card px-4 py-3">
        {LEGEND.map((l) => (
          <div key={l.label} className="flex items-center gap-2 text-xs text-muted-foreground">
            <span className={`h-2.5 w-2.5 rounded-full ${l.dot}`} /> {l.label}
          </div>
        ))}
      </div>
      <CrudModule module={MODULES.scorecard} subtitle="Performance ratings for carriers and vendors." />
    </div>
  );
}
